import * as React from "react";
const SvgThreeDots = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentcolor", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0M17 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0M3 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0", clipRule: "evenodd" }));
export default SvgThreeDots;
